import { lazy } from "react";
import { Navigate } from "react-router-dom";
import AdminLayout from "src/layouts/full - Copy/adminLayout";
import UserProfile from "src/views/UserProfile";
import AdminPermissions from "src/views/adminUsers/AdminPermissionsPage";
import AdminUsers from "src/views/adminUsers/AdminUsers";
import ReportPage from "src/views/adminUsers/ReportPage";
import CompleteProfile from "src/views/authentication/CompleteProfile";
import PasswordReset from "src/views/authentication/PasswordReset";
import Verify from "src/views/authentication/Verify";
import Category from "src/views/category/Category";
import AdminLeads from "src/views/dashboard/AdminLeadsHistory";
import AdminTransactions from "src/views/dashboard/AdminTransactions";
import FileJobs from "src/views/dashboard/FileJobs";
import Redirect from "src/views/dashboard/Redirect";
import UserDashboard from "src/views/dashboard/UserDashboard";
import EnrollFormPage from "src/views/enrollForm/EnrollForm";
import LeadsPage from "src/views/leads/LeadsPage";
import AdminProductPage from "src/views/product-page/AdminProductPage";
import AddProducts from "src/views/product-page/add_products";
import EditProducts from "src/views/product-page/edit_products";
import ReferralPage from "src/views/referrals/Referrals";
import Loadable from "../layouts/full/shared/loadable/Loadable";

import OldReportPage from "src/views/adminUsers/OldReportPage";
import Forbidden from "src/views/authentication/403Error";
import Error from "src/views/authentication/Error";
import AuthLogin from "src/views/authentication/Login";
import MobileLogin from "src/views/authentication/MobileLogin";
import Register from "src/views/authentication/Register";
import AdminDashboard from "src/views/dashboard/AdminDashboard";
import AdminPayout from "src/views/dashboard/AdminPayouts";
import AdminReports from "src/views/dashboard/AdminReports";
import Products from "src/views/dashboard/Products";
import Transactions from "src/views/dashboard/Transactions";
import ProductPage from "src/views/product-page/ProductPage";
/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));
const BlankLayout = Loadable(
  lazy(() => import("../layouts/blank/BlankLayout"))
);

/* ****Pages***** */

const Router = [
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { path: "/admin/", element: <AdminDashboard /> },
      { path: "/admin/permissions", element: <AdminPermissions /> },
      { path: "/admin/transactions", element: <AdminTransactions /> },
      { path: "/admin/report-history", element: <AdminReports /> },
      { path: "/admin/product-history", element: <AdminPayout /> },
      { path: "/admin/payouts", element: <AdminTransactions /> },
      { path: "/admin/leads", element: <AdminLeads /> },
      { path: "/admin/file-jobs", element: <FileJobs /> },
      { path: "/admin/products", exact: true, element: <AdminProductPage /> },
      { path: "/admin/add-products", exact: true, element: <AddProducts /> },
      {
        path: "/admin/edit-products/:productId",
        exact: true,
        element: <EditProducts />,
      },
      { path: "/admin/users", exact: true, element: <AdminUsers /> },
      { path: "/admin/report", exact: true, element: <ReportPage /> },
      { path: "/admin/old-report", exact: true, element: <OldReportPage /> },
    ],
  },
  {
    path: "/",
    element: <FullLayout />,
    children: [
      { path: "/", exact: true, element: <Redirect /> },
      {
        path: "/dashboard",
        exact: true,
        element: <UserDashboard />,
      },
      {
        path: "/dashboard/transactions",
        exact: true,
        element: <Transactions />,
      },
      { path: "/products", exact: true, element: <Products /> },
      {
        path: "/products/categories/:category",
        exact: true,
        element: <Products />,
      },
      { path: "/products/cat/:category", exact: true, element: <Products /> },
      { path: "/products/:productId", element: <ProductPage /> },
      { path: "/join/:productId", element: <EnrollFormPage /> },

      { path: "/leads", exact: true, element: <LeadsPage /> },
      { path: "/referrals", exact: true, element: <ReferralPage /> },
      { path: "/categories", exact: true, element: <Category /> },
      { path: "/profile", exact: true, element: <UserProfile /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: "/auth",
    element: <BlankLayout />,
    children: [
      { path: "404", element: <Error /> },
      { path: "403", element: <Forbidden /> },
      { path: "/auth/verify", element: <Verify /> },
      { path: "/auth/register", element: <Register /> },
      { path: "/auth/onboarding", element: <CompleteProfile /> },
      { path: "/auth/login", element: <MobileLogin /> },
      { path: "/auth/password_login", element: <AuthLogin /> },
      { path: "/auth/reset-password", exact: true, element: <PasswordReset /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
